<div class="modal-header">
    <span class="fs-4 fw-600">{{contractSel.policy.code}} - {{contractSel.insured.names}} {{contractSel.insured.surname}} {{contractSel.insured.lastname}}</span>
</div>
<div class="modal-body">
    <div class="row mt-3">
        <div class="col-md-4">
            Nombre Contratante
            <label class="form-control">{{contractSel.policy.entity.name}} </label>
        </div>
        <div class="col-md-2">
            RUT
            <label class="form-control">{{contractSel.policy.entity.rut | numberPipe: '1.0-0'}}-{{contractSel.policy.entity.dv | uppercase}}</label>
        </div>
        <div class="col-md-4">
            Grupo
            <label class="form-control">{{contractSel.group.name }}</label>
        </div>
        <div class="col-md-2">
            Campo
            <label class="form-control">{{contractSel.group.campus?.acronym}}</label>
        </div>
    </div>
    <hr>
    <h5>Valores Póliza</h5>
    <div class="row mt-3">
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            CARGAS
          <label class="form-control">{{contractSel.coveredLives | numberPipe: '1.0-0'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            CAPITAL
          <label class="form-control">{{contractSel.capital | numberPipe: '1.0-0'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            TOTAL VIDA
           <label class="form-control">$ {{contractSel.totalVida | numberPipe: '1.0-0'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            TOTAL SALUD
          <label class="form-control">$ {{contractSel.totalSalud | numberPipe: '1.0-0'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            TOTAL UF 
           <label class="form-control">{{contractSel.totalUF | numberPipe: '1.0-6'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            TOTAL PESOS
           <label class="form-control">$ {{contractSel.totalPesos | numberPipe: '1.0-0'}}</label>
        </div>
    </div>
    <h5 class="mt-3">Detalles</h5>
    <div class="row mt-3">
            <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2">
                VIDA
                <label class="form-control">{{contractSel.life | numberPipe: '1.0-6'}} </label>
            </div>
       
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2">
            CATAS
            <label class="form-control">{{contractSel.catas  | numberPipe: '1.0-6'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            DENTAL
            <label class="form-control">{{contractSel.dental | numberPipe: '1.0-6' }}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            INV 2/3
            <label class="form-control">{{contractSel.inv23 | numberPipe: '1.0-6'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            INVACC
            <label class="form-control">{{contractSel.invacc | numberPipe: '1.0-6'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            MA
            <label class="form-control">{{contractSel.ma | numberPipe: '1.0-6'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            SALUD
            <label class="form-control">{{contractSel.health  | numberPipe: '1.0-6'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            TOTALES
            <label class="form-control">{{contractSel.totales | numberPipe: '1.0-6'}} </label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2">
            EXENTO
            <label class="form-control">{{contractSel.exento | numberPipe: '1.0-6'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2">
            AFECTO
            <label class="form-control">{{contractSel.afecto | numberPipe: '1.0-6'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            IVA
            <label class="form-control">{{contractSel.iva | numberPipe: '1.0-6'}}</label>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-6 mt-2" >
            UF
            <label class="form-control">{{contractSel.uf | numberPipe: '1.0-6'}}</label>
        </div>
    </div>
</div>
